import _ from 'lodash';

let fieldComponents = {};

let coreFields = require.context('../fields/core', false, /^\.\/field([\w-_]+)\.vue$/);

_.forEach(coreFields.keys(), key => {
  let compName = key.replace(/^\.\//, '').replace(/\.vue/, '');
  fieldComponents[compName] = coreFields(key).default;
});

export default fieldComponents;
